// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homepage-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 15px;
  height: 100vh; /* or any fixed height */
  /* background: linear-gradient(
    to right,
    #ffecd2 0%, 
    #fcb69f 100%   
  ); */
  background: var(--card-bg, rgb(4, 4, 4));
  overflow-y: auto;
}

.homepage-header-section {
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background: linear-gradient(to right, #ff7e5f, #feb47b); */
  border-radius: 12px;
  width: 102%;
  margin-left: -12px;
}

.ootshav-logo {
  font-size: 48px;
  font-weight: bold;
  font-family: "Pacifico", cursive;
  background: linear-gradient(to right, #ff512f, #dd2476);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-top: 20px;
}

.homepage-main-section {
  position: relative;
  height: 300px;
  width: 100%;
  background: #f6ede1;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.event-sticker.large {
  width: 80%;
  height: 85%;
  border-radius: 20px;
  /* background: linear-gradient(to right, #ffb75e, #ed8f03); */
  background: linear-gradient(to right, #ffd28d, #f5b84c);
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  text-align: center;
  cursor: pointer;
  padding: 10px;
}

.event-sticker.small {
  width: 200px;
  height: 220px;
  border-radius: 15px;
  background: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  text-align: center;
  cursor: pointer;
  padding: 10px;
}

.event-image {
  width: 100%;
  height: 70%;
  object-fit: cover;
  border-radius: 10px;
}

.event-title {
  font-size: 18px;
  font-weight: bold;
  margin: 8px 0 4px;
}

.event-date {
  font-size: 14px;
  color: gray;
}

.add-event-btn {
  position: absolute;
  bottom: 20px;
  right: 20px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: none;
  background: linear-gradient(to right, #36d1dc, #5b86e5);
  color: white;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.homepage-bottom-section {
  margin-top: 0px;
  display: flex;
  flex-direction: row;
  gap: 5px;
  display: block; /* let .event-list handle layout */
}

.section-title {
  font-size: 22px;
  margin-bottom: 15px;
  color: linear-gradient(135deg, #FFD700 0%, #FFA500 100%);
}

.event-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); /* ✅ auto-fit event stickers */
  gap: 15px;
  padding-bottom: 10px;
}

.event-list-container {
  position: relative;
  display: flex;
  flex-direction: column;
}

.event-actions {
  display: flex;
  justify-content: flex-end; /* push button to right */
  margin-top: 15px;
}

.add-event-button {
  padding: 10px 18px;
  border-radius: 8px;
  background-color: #f77f00;
  color: white;
  font-size: 1rem;
  font-weight: bold;
  border: none;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
  transition: transform 0.2s ease-in-out, background 0.2s;
}

.add-event-button:hover {
  transform: scale(1.05);
  background-color: #ff9f1c;
}

/* Date Filter Section */
.date-filter-container {
    background: white;
    padding: 24px;
    border-radius: 16px;
    margin-bottom: 40px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  }
  
  .date-filter-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
  }
  
  .date-filter-header h3 {
    font-size: 22px;
    font-weight: 700;
    color: #2c2c2c;
    margin: 0;
  }
  
  .date-filter-controls {
    display: flex;
    gap: 16px;
    align-items: center;
    flex-wrap: wrap;
  }
  
  .date-select {
    padding: 12px 16px;
    border: 2px solid #e0e0e0;
    border-radius: 10px;
    font-size: 16px;
    font-weight: 500;
    background: white;
    cursor: pointer;
    transition: all 0.3s ease;
    min-width: 150px;
  }
  
  .date-select:focus {
    outline: none;
    border-color: #007BFF;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
  }
  
  .filter-apply-btn {
    padding: 12px 28px;
    background: #007BFF;
    color: white;
    border: none;
    border-radius: 10px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  
  .filter-apply-btn:hover {
    background: #0056b3;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
  }
  
  /* Section Styles */
  .events-section {
    margin-bottom: 60px;
  }
  
  .section-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 24px;
  }
  
  .section-icon {
    width: 32px;
    height: 32px;
    color: #007BFF;
  }
  
  .section-title {
    font-size: 28px;
    font-weight: 700;
    color: white;
    margin: 0;
  }
  
  .section-subtitle {
    font-size: 15px;
    color: lightcyan;
    margin-left: 44px;
    margin-top: 4px;
  }
  
  /* Personal Events Section */
  .personal-events-section {
    background: none;
    padding: 32px;
    border-radius: 20px;
  }
  
  .personal-event {
    border: 2px solid rgba(255, 105, 180, 0.3);
  }
  
  .event-badge {
    position: absolute;
    top: 12px;
    right: 12px;
    background: rgba(255, 105, 180, 0.9);
    color: white;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
  }
  
  .event-connection {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #007BFF;
    font-weight: 600;
    margin: 8px 0;
  }
  
  /* Home Country Section */
  .home-country-section {
    background: linear-gradient(135deg, rgba(135, 206, 250, 0.1) 0%, rgba(173, 216, 230, 0.2) 100%);
    padding: 32px;
    border-radius: 20px;
  }
  
  /* Worldwide Section */
  .worldwide-section {
    background: linear-gradient(135deg, rgba(144, 238, 144, 0.1) 0%, rgba(152, 251, 152, 0.2) 100%);
    padding: 32px;
    border-radius: 20px;
  }
  
  /* Local Famous Section */
  .local-famous-section {
    background: linear-gradient(135deg, rgba(255, 215, 0, 0.1) 0%, rgba(255, 223, 0, 0.2) 100%);
    padding: 32px;
    border-radius: 20px;
  }
  
  .local-event {
    border: 2px solid rgba(255, 215, 0, 0.3);
  }
  
  .local-badge {
    position: absolute;
    top: 12px;
    right: 12px;
    background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%);
    color: #000;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
  }
  
  .event-region,
  .event-country {
    font-size: 13px;
    color: #007BFF;
    font-weight: 600;
    margin: 6px 0;
  }
  
  .event-description {
    font-size: 12px;
    color: #666;
    margin: 8px 0;
    line-height: 1.4;
  }
  
  /* Event List */
  .event-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 24px;
  }
  
  .event-sticker {
    position: relative;
    background: white;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    cursor: pointer;
  }
  
  .event-sticker.medium {
    padding: 16px;
  }
  
  .event-image {
    width: 100%;
    height: 180px;
    object-fit: cover;
    border-radius: 12px;
    margin-bottom: 12px;
  }
  
  .event-title {
    font-size: 18px;
    font-weight: 700;
    color: #2c2c2c;
    margin: 8px 0;
  }
  
  .event-date {
    font-size: 13px;
    color: #888;
    margin-top: 8px;
  }
  
  /* Loading State */
  .homepage-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 60vh;
    gap: 20px;
  }
  
  .loading-spinner {
    width: 50px;
    height: 50px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #007BFF;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  /* Responsive Design */
  @media (max-width: 768px) {
    .date-filter-controls {
      flex-direction: column;
      width: 100%;
    }
  
    .date-select,
    .filter-apply-btn {
      width: 100%;
    }
  
    .section-title {
      font-size: 22px;
    }
  
    .event-list {
      grid-template-columns: 1fr;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Pages/HomePage/HomePage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,aAAa,EAAE,wBAAwB;EACvC;;;;MAII;EACJ,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,6DAA6D;EAC7D,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,uDAAuD;EACvD,6BAA6B;EAC7B,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,6DAA6D;EAC7D,uDAAuD;EACvD,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uDAAuD;EACvD,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc,EAAE,kCAAkC;AACpD;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,4DAA4D,EAAE,8BAA8B;EAC5F,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB,EAAE,yBAAyB;EACpD,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,uDAAuD;AACzD;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,0CAA0C;EAC5C;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;EACX;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,4CAA4C;EAC9C;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;IAC3B,6CAA6C;EAC/C;;EAEA,mBAAmB;EACnB;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;;EAEA,4BAA4B;EAC5B;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,oCAAoC;IACpC,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,aAAa;EACf;;EAEA,yBAAyB;EACzB;IACE,+FAA+F;IAC/F,aAAa;IACb,mBAAmB;EACrB;;EAEA,sBAAsB;EACtB;IACE,+FAA+F;IAC/F,aAAa;IACb,mBAAmB;EACrB;;EAEA,yBAAyB;EACzB;IACE,2FAA2F;IAC3F,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,6DAA6D;IAC7D,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;;IAEE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,eAAe;IACf,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;;EAEA,eAAe;EACf;IACE,aAAa;IACb,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;IACzC,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,aAAa;EACf;;EAEA;IACE,eAAe;IACf,WAAW;IACX,eAAe;EACjB;;EAEA,kBAAkB;EAClB;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,kCAAkC;EACpC;;EAEA;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC;;EAEA,sBAAsB;EACtB;IACE;MACE,sBAAsB;MACtB,WAAW;IACb;;IAEA;;MAEE,WAAW;IACb;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,0BAA0B;IAC5B;EACF","sourcesContent":[".homepage-container {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 15px;\n  height: 100vh; /* or any fixed height */\n  /* background: linear-gradient(\n    to right,\n    #ffecd2 0%, \n    #fcb69f 100%   \n  ); */\n  background: var(--card-bg, rgb(4, 4, 4));\n  overflow-y: auto;\n}\n\n.homepage-header-section {\n  height: 100px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* background: linear-gradient(to right, #ff7e5f, #feb47b); */\n  border-radius: 12px;\n  width: 102%;\n  margin-left: -12px;\n}\n\n.ootshav-logo {\n  font-size: 48px;\n  font-weight: bold;\n  font-family: \"Pacifico\", cursive;\n  background: linear-gradient(to right, #ff512f, #dd2476);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  margin-top: 20px;\n}\n\n.homepage-main-section {\n  position: relative;\n  height: 300px;\n  width: 100%;\n  background: #f6ede1;\n  border-radius: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.event-sticker.large {\n  width: 80%;\n  height: 85%;\n  border-radius: 20px;\n  /* background: linear-gradient(to right, #ffb75e, #ed8f03); */\n  background: linear-gradient(to right, #ffd28d, #f5b84c);\n  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);\n  overflow: hidden;\n  text-align: center;\n  cursor: pointer;\n  padding: 10px;\n}\n\n.event-sticker.small {\n  width: 200px;\n  height: 220px;\n  border-radius: 15px;\n  background: white;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  text-align: center;\n  cursor: pointer;\n  padding: 10px;\n}\n\n.event-image {\n  width: 100%;\n  height: 70%;\n  object-fit: cover;\n  border-radius: 10px;\n}\n\n.event-title {\n  font-size: 18px;\n  font-weight: bold;\n  margin: 8px 0 4px;\n}\n\n.event-date {\n  font-size: 14px;\n  color: gray;\n}\n\n.add-event-btn {\n  position: absolute;\n  bottom: 20px;\n  right: 20px;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  border: none;\n  background: linear-gradient(to right, #36d1dc, #5b86e5);\n  color: white;\n  font-size: 28px;\n  font-weight: bold;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.homepage-bottom-section {\n  margin-top: 0px;\n  display: flex;\n  flex-direction: row;\n  gap: 5px;\n  display: block; /* let .event-list handle layout */\n}\n\n.section-title {\n  font-size: 22px;\n  margin-bottom: 15px;\n  color: linear-gradient(135deg, #FFD700 0%, #FFA500 100%);\n}\n\n.event-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); /* ✅ auto-fit event stickers */\n  gap: 15px;\n  padding-bottom: 10px;\n}\n\n.event-list-container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n.event-actions {\n  display: flex;\n  justify-content: flex-end; /* push button to right */\n  margin-top: 15px;\n}\n\n.add-event-button {\n  padding: 10px 18px;\n  border-radius: 8px;\n  background-color: #f77f00;\n  color: white;\n  font-size: 1rem;\n  font-weight: bold;\n  border: none;\n  cursor: pointer;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.2);\n  transition: transform 0.2s ease-in-out, background 0.2s;\n}\n\n.add-event-button:hover {\n  transform: scale(1.05);\n  background-color: #ff9f1c;\n}\n\n/* Date Filter Section */\n.date-filter-container {\n    background: white;\n    padding: 24px;\n    border-radius: 16px;\n    margin-bottom: 40px;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n  }\n  \n  .date-filter-header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 20px;\n  }\n  \n  .date-filter-header h3 {\n    font-size: 22px;\n    font-weight: 700;\n    color: #2c2c2c;\n    margin: 0;\n  }\n  \n  .date-filter-controls {\n    display: flex;\n    gap: 16px;\n    align-items: center;\n    flex-wrap: wrap;\n  }\n  \n  .date-select {\n    padding: 12px 16px;\n    border: 2px solid #e0e0e0;\n    border-radius: 10px;\n    font-size: 16px;\n    font-weight: 500;\n    background: white;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    min-width: 150px;\n  }\n  \n  .date-select:focus {\n    outline: none;\n    border-color: #007BFF;\n    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);\n  }\n  \n  .filter-apply-btn {\n    padding: 12px 28px;\n    background: #007BFF;\n    color: white;\n    border: none;\n    border-radius: 10px;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n  }\n  \n  .filter-apply-btn:hover {\n    background: #0056b3;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);\n  }\n  \n  /* Section Styles */\n  .events-section {\n    margin-bottom: 60px;\n  }\n  \n  .section-header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 24px;\n  }\n  \n  .section-icon {\n    width: 32px;\n    height: 32px;\n    color: #007BFF;\n  }\n  \n  .section-title {\n    font-size: 28px;\n    font-weight: 700;\n    color: white;\n    margin: 0;\n  }\n  \n  .section-subtitle {\n    font-size: 15px;\n    color: lightcyan;\n    margin-left: 44px;\n    margin-top: 4px;\n  }\n  \n  /* Personal Events Section */\n  .personal-events-section {\n    background: none;\n    padding: 32px;\n    border-radius: 20px;\n  }\n  \n  .personal-event {\n    border: 2px solid rgba(255, 105, 180, 0.3);\n  }\n  \n  .event-badge {\n    position: absolute;\n    top: 12px;\n    right: 12px;\n    background: rgba(255, 105, 180, 0.9);\n    color: white;\n    padding: 4px 12px;\n    border-radius: 12px;\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n  }\n  \n  .event-connection {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 13px;\n    color: #007BFF;\n    font-weight: 600;\n    margin: 8px 0;\n  }\n  \n  /* Home Country Section */\n  .home-country-section {\n    background: linear-gradient(135deg, rgba(135, 206, 250, 0.1) 0%, rgba(173, 216, 230, 0.2) 100%);\n    padding: 32px;\n    border-radius: 20px;\n  }\n  \n  /* Worldwide Section */\n  .worldwide-section {\n    background: linear-gradient(135deg, rgba(144, 238, 144, 0.1) 0%, rgba(152, 251, 152, 0.2) 100%);\n    padding: 32px;\n    border-radius: 20px;\n  }\n  \n  /* Local Famous Section */\n  .local-famous-section {\n    background: linear-gradient(135deg, rgba(255, 215, 0, 0.1) 0%, rgba(255, 223, 0, 0.2) 100%);\n    padding: 32px;\n    border-radius: 20px;\n  }\n  \n  .local-event {\n    border: 2px solid rgba(255, 215, 0, 0.3);\n  }\n  \n  .local-badge {\n    position: absolute;\n    top: 12px;\n    right: 12px;\n    background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%);\n    color: #000;\n    padding: 4px 12px;\n    border-radius: 12px;\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n  }\n  \n  .event-region,\n  .event-country {\n    font-size: 13px;\n    color: #007BFF;\n    font-weight: 600;\n    margin: 6px 0;\n  }\n  \n  .event-description {\n    font-size: 12px;\n    color: #666;\n    margin: 8px 0;\n    line-height: 1.4;\n  }\n  \n  /* Event List */\n  .event-list {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n    gap: 24px;\n  }\n  \n  .event-sticker {\n    position: relative;\n    background: white;\n    border-radius: 16px;\n    overflow: hidden;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n    transition: all 0.3s ease;\n    cursor: pointer;\n  }\n  \n  .event-sticker.medium {\n    padding: 16px;\n  }\n  \n  .event-image {\n    width: 100%;\n    height: 180px;\n    object-fit: cover;\n    border-radius: 12px;\n    margin-bottom: 12px;\n  }\n  \n  .event-title {\n    font-size: 18px;\n    font-weight: 700;\n    color: #2c2c2c;\n    margin: 8px 0;\n  }\n  \n  .event-date {\n    font-size: 13px;\n    color: #888;\n    margin-top: 8px;\n  }\n  \n  /* Loading State */\n  .homepage-loading {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 60vh;\n    gap: 20px;\n  }\n  \n  .loading-spinner {\n    width: 50px;\n    height: 50px;\n    border: 4px solid #f3f3f3;\n    border-top: 4px solid #007BFF;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n  }\n  \n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n  \n  /* Responsive Design */\n  @media (max-width: 768px) {\n    .date-filter-controls {\n      flex-direction: column;\n      width: 100%;\n    }\n  \n    .date-select,\n    .filter-apply-btn {\n      width: 100%;\n    }\n  \n    .section-title {\n      font-size: 22px;\n    }\n  \n    .event-list {\n      grid-template-columns: 1fr;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
